import { cn } from '@/lib/utils';
import { Star } from '@ui/Icons';

type RatingInputProps = {
  rating: number;
  setRating: React.Dispatch<React.SetStateAction<number>>;
};
export default function RatingStarInput({
  rating,
  setRating,
}: RatingInputProps) {
  return (
    <div className="ml-auto flex flex-row-reverse justify-center">
      {Array.from({ length: 5 }, (_, i) => (
        <Star
          key={i}
          onClick={() => setRating(5 - i)}
          className={cn(
            'peer cursor-pointer hover:scale-125 hover:text-yellow-400 peer-hover:text-yellow-400',
            5 - i <= rating ? 'text-yellow-400' : 'text-neutral-400'
          )}
        />
      ))}
    </div>
  );
}
